import React from "react";
import { Header } from "../../../components/Header";
import "./styles.less";
import { Footer } from "../../../components/FooterV2";
import { HomeTryOn } from "../../../blocks/home-try-on";

import { ReplaceOkta } from "./ReplaceOkta";
import { SolutionTable } from "./SolutionTable";
import { SolutionProductivity } from "./SolutionProductivity";
import Helmet from "react-helmet";
import { ManufacturingMarquee } from "./ManufacturingMarquee";
import { ManufacturingProductivity } from "./ManufacturingProductivity";
import { SolutionProduct } from "../../../components/SolutionProduct";
import { SolutionBanner } from "../../../blocks/solution-banner-new";
import { useTranslation } from "react-i18next";

export const OktaPage = () => {
  const { t } = useTranslation();
  const banner = {
    title: t("solution.okta.banner.title"),
    subtitle: t("solution.okta.banner.description"),
    background: "solution-okta-banner-2.png",
    link: "https://www.authing.cn/authingform?fromTag=okta",
    download:
      "/authingform?fromTag=Okta&download=https://host.huiju.cool/file/0b329799915946c29238571c6ec03c55",
  };
  return (
    <div className="okta-page">
      <Helmet>
        <title>中国替代Okta的身份认证与权限管理解决方案-Authing身份云</title>
      </Helmet>
      <Header mode="dark" hasNotice />
      <SolutionBanner {...banner} rcodeUrl="solution-okta-1.png" />
      <ReplaceOkta />
      <ManufacturingMarquee />
      <SolutionTable />
      <SolutionProduct />
      <HomeTryOn hasBg />
      <Footer />
    </div>
  );
};
